import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../context/DarkModeContext';
import Footer from '../components/Footer';
import '../styles/HomePage.css';

const tools = [
  {
    id: 'text-compare',
    title: 'Text Compare',
    description: 'Compare two texts and highlight the differences',
    icon: '📝',
    available: true
  },
  {
    id: 'text-checker',
    title: 'Text Checker',
    description: 'Check word count, clean blank lines, change case, and find special characters.',
    icon: '✔️',
    available: true
  },
  {
    id: 'json-validator',
    title: 'JSON Validator',
    description: 'Validate and format JSON data',
    icon: '🔍',
    available: true
  },
  {
    id: 'json-compare',
    title: 'JSON Compare',
    description: 'Compare two JSON objects and find differences',
    icon: '⚖️',
    available: true
  }
];

export default function HomePage() {
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useDarkMode();

  const handleToolClick = (toolId) => {
    navigate(`/${toolId}`);
  };

  return (
    <div className={`home-container ${darkMode ? 'dark-theme' : ''}`} style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <button
        onClick={toggleDarkMode}
        className="dark-mode-toggle"
        style={{ 
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 1000,
          color: '#fff',
          fontSize: '1rem',
          padding: '8px 16px',
          borderRadius: '4px',
          backgroundColor: '#388e3c',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '40px'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#2e7d32'}
        onMouseLeave={(e) => e.target.style.backgroundColor = '#388e3c'}
      >
        <span className="dark-mode-text">
          {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
        </span>
        <span className="dark-mode-icon">
          {darkMode ? '☀️' : '🌙'}
        </span>
      </button>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 40 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <img src="/favicon.png" alt="Text-JSON Tools Logo" style={{ height: 44, width: 44, maxWidth: '12vw', maxHeight: '12vw', objectFit: 'contain', verticalAlign: 'middle' }} />
          <span style={{ color: darkMode ? '#4CAF50' : '#006400', fontWeight: 800, fontSize: 36, margin: 0, lineHeight: 1 }}>Text-JSON Tools</span>
        </div>
        <p style={{ color: darkMode ? '#e0e0e0' : '#666', fontSize: 18, margin: '8px 0 0 0' }}>Select a tool to get started</p>
      </div>
      
      <div className="tools-grid">
        {tools.map((tool) => (
          <div
            key={tool.id}
            className={`tool-card ${!tool.available ? 'coming-soon' : ''}`}
            onClick={() => tool.available && handleToolClick(tool.id)}
          >
            <div className="tool-icon">{tool.icon}</div>
            <h2 className="tool-title">{tool.title}</h2>
            <p className="tool-description">{tool.description}</p>
            {!tool.available && <span className="coming-soon-badge">Coming Soon</span>}
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
} 